<div class="wa-stack wa-gap-l">
  <wa-card>
    <div slot="header" class="wa-heading-s">Parameter Set</div>

    <div class="toolbar">
      <div class="selection-block">
        <wa-select
          id="parameter-set-select"
          [value]="selectedValue()"
          (valueChange)="onParameterSetChange($event)"
          [label]="selectedParameterSetLabel() ? 'Selected: ' + selectedParameterSetLabel() : ''">
          @for (parameterSet of displayedParameterSets(); track parameterSet.id) {
            <wa-option [value]="parameterSet.id.toString()">
              {{ parameterSet.name }}{{ selectedParameterSet()?.id === parameterSet.id && changed() ? ' *' : '' }}{{ isFallbackParameterSet(parameterSet) ? ' (template)' : '' }}{{ isDefault(parameterSet) ? ' (default)' : '' }}
            </wa-option>
          }
        </wa-select>
      </div>

      <div class="button-row">
        <wa-button variant="neutral" appearance="filled" (click)="update()" [disabled]="!canUpdate()">
          update
        </wa-button>
        <wa-button variant="neutral" appearance="filled" (click)="saveAsNew()" [disabled]="!canSaveAsNew()">
          save as new
        </wa-button>
        <wa-button variant="danger" appearance="filled" (click)="remove()" [disabled]="!canRemove()">
          remove
        </wa-button>
        @if (processing()) {
          <wa-button variant="warning" appearance="filled" (click)="abort()">
            <wa-icon slot="prefix" name="octagon-exclamation"></wa-icon>
            abort optimization
          </wa-button>
        } @else {
          <wa-button variant="brand" appearance="filled" (click)="solve()" [disabled]="!canOptimize()">
            <wa-icon slot="prefix" name="right-from-line"></wa-icon>
            optimize
          </wa-button>
        }
      </div>
    </div>

    @if (isFallbackSelected()) {
      <wa-callout variant="brand" class="fallback-hint">
        <wa-icon slot="icon" name="circle-info" variant="regular"></wa-icon>
        <strong>DEFAULT template active.</strong>
        This profile exists only locally. Use <strong>save as new</strong> to create a persistent parameter set.
      </wa-callout>
    }

    @if (selectedParameterSet() && !canUpdate() && changed()) {
      <wa-callout variant="warning">
        <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
        The selected parameter set is not owned by the current user, so changes can only be saved via <strong>save as new</strong>.
      </wa-callout>
    }
  </wa-card>

  @if (selectedParameterSet()) {
    <wa-card>
      <div slot="header" class="wa-heading-s">Optimization Parameters</div>

      <wa-tab-group>
        <wa-tab panel="supervision_parameters">Supervision</wa-tab>
        <wa-tab panel="correction_parameters">Correction</wa-tab>

        <wa-tab-panel name="supervision_parameters">
          <div class="wa-grid slider-grid">
            @for (param of supervisionSliders(); track param.key) {
              <app-slider
                [name]="param.key"
                [value]="param.value"
                (valueChangeEvent)="onSupervisionParamChange(param.key, $event)">
              </app-slider>
            }
          </div>
        </wa-tab-panel>

        <wa-tab-panel name="correction_parameters">
          <div class="wa-grid slider-grid">
            @for (param of correctionSliders(); track param.key) {
              <app-slider
                [name]="param.key"
                [value]="param.value"
                (valueChangeEvent)="onCorrectionParamChange(param.key, $event)">
              </app-slider>
            }
          </div>
        </wa-tab-panel>
      </wa-tab-group>
    </wa-card>
  } @else {
    <wa-callout variant="brand">
      <wa-icon slot="icon" name="circle-info" variant="regular"></wa-icon>
      Select a parameter set to edit supervision and correction sliders.
    </wa-callout>
  }

  <app-export-panel
    [optimizationFailed]="solutionData().latest_failed"
    [processing]="processing()"
    [survey]="survey()">
  </app-export-panel>
</div>

